import { useEffect, useState } from "react";

// The night. Edit this to whenever the actual date is.
// Format: YYYY-MM-DDTHH:MM:SS±HH:MM
// Sunday May 10, 2026 at 8pm Central (US DST is on, so UTC offset is -05:00).
// In winter (Nov–Mar) Central is UTC-6 — change the offset accordingly.
const DATE_TARGET_ISO = "2026-05-10T20:00:00-05:00";

function getRemaining(targetMs) {
  const diff = targetMs - Date.now();
  if (diff <= 0) return null;
  const totalSecs = Math.floor(diff / 1000);
  return {
    days: Math.floor(totalSecs / 86400),
    hours: Math.floor((totalSecs % 86400) / 3600),
    minutes: Math.floor((totalSecs % 3600) / 60),
    seconds: totalSecs % 60,
  };
}

function pad(n) {
  return String(n).padStart(2, "0");
}

export default function Finale({ update }) {
  const targetMs = new Date(DATE_TARGET_ISO).getTime();
  const [hearts, setHearts] = useState([]);
  const [remaining, setRemaining] = useState(() => getRemaining(targetMs));

  useEffect(() => {
    const t = setInterval(() => setRemaining(getRemaining(targetMs)), 1000);
    return () => clearInterval(t);
  }, [targetMs]);

  useEffect(() => {
    const spawn = () => {
      setHearts((h) => [
        ...h.slice(-30),
        {
          id: Math.random(),
          left: Math.random() * 100,
          duration: 6 + Math.random() * 6,
          size: 14 + Math.random() * 22,
          delay: Math.random() * 2,
          drift: (Math.random() - 0.5) * 80,
          opacity: 0.4 + Math.random() * 0.5,
        },
      ]);
    };
    const i = setInterval(spawn, 600);
    return () => clearInterval(i);
  }, []);

  return (
    <section
      id="finale-anchor"
      className="section finale-section scene-mount"
    >
      <div className="hearts-layer" aria-hidden="true">
        {hearts.map((h) => (
          <span
            key={h.id}
            className="heart-piece"
            style={{
              left: `${h.left}%`,
              fontSize: h.size,
              opacity: h.opacity,
              animationDuration: `${h.duration}s`,
              animationDelay: `${h.delay}s`,
              "--drift": `${h.drift}px`,
            }}
          >
            ♥
          </span>
        ))}
      </div>

      <div className="finale-inner">
        <p className="section-eyebrow">that's it</p>
        <h2 className="finale-title">you made it.</h2>

        <div className="ticket">
          <div className="ticket-header">
            <span className="ticket-star">✦</span>
            <span className="ticket-pair">angel × dua</span>
            <span className="ticket-star">✦</span>
          </div>
          <div className="ticket-divider" />

          <div className="ticket-body">
            <div className="ticket-when">sunday · 8pm cst</div>
            <div className="ticket-what">re-animal game</div>
          </div>

          <div className="ticket-divider" />

          {remaining ? (
            <div className="ticket-countdown" aria-live="polite">
              <div className="cd-cell">
                <span className="cd-num">{pad(remaining.days)}</span>
                <span className="cd-label">days</span>
              </div>
              <span className="cd-sep">:</span>
              <div className="cd-cell">
                <span className="cd-num">{pad(remaining.hours)}</span>
                <span className="cd-label">hrs</span>
              </div>
              <span className="cd-sep">:</span>
              <div className="cd-cell">
                <span className="cd-num">{pad(remaining.minutes)}</span>
                <span className="cd-label">min</span>
              </div>
              <span className="cd-sep">:</span>
              <div className="cd-cell">
                <span className="cd-num">{pad(remaining.seconds)}</span>
                <span className="cd-label">sec</span>
              </div>
            </div>
          ) : (
            <div className="ticket-now">the night is here ♥</div>
          )}
        </div>

        <p className="finale-signoff">— angel</p>

        <button
          className="btn btn-ghost"
          onClick={() => update({ scene: "intro", qIndex: 0 })}
          style={{ marginTop: 8 }}
        >
          <span className="btn-text">↺ start over</span>
        </button>
      </div>
    </section>
  );
}
